import {
  FETCH_SWITCH_TYPE,
  FETCH_SWITCH_TYPE_START,
  FETCH_SWITCH_TYPE_END,
  FETCH_SWITCH_TYPE_ERROR,
  CLEAR_SWITCH_TYPE,
} from '../actions/types';
import { switchTypes } from '../../util/constants';

const initialState = {
  isLoading: false,
  switchType: switchTypes.METASWITCH,
  error: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_SWITCH_TYPE_START:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_SWITCH_TYPE:
      return {
        ...state,
        switchType: action.payload.switchType,
      };
    case FETCH_SWITCH_TYPE_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case FETCH_SWITCH_TYPE_END:
      return {
        ...state,
        isLoading: false,
      };
    case CLEAR_SWITCH_TYPE:
      return initialState;
    default:
      return state;
  }
}
